function getDateFormatParts(locale) {
  if (!locale) {
    return [];
  }
  try {
    const format = Intl.DateTimeFormat(locale, {
      dateStyle: "short",
      timeStyle: "medium"
    });
    return format.formatToParts(Date.now()).filter((part) => part.type !== "literal").map((part) => part.type);
  } catch {
    return [];
  }
}
var SupportedDateParts = /* @__PURE__ */ ((SupportedDateParts2) => {
  SupportedDateParts2["DAY"] = "DAY";
  SupportedDateParts2["MONTH"] = "MONTH";
  SupportedDateParts2["YEAR"] = "YEAR";
  return SupportedDateParts2;
})(SupportedDateParts || {});
const supportedPartsValues = Object.values(SupportedDateParts);
const isSupportedDatePart = (part) => supportedPartsValues.includes(part.toUpperCase());
export {
  SupportedDateParts,
  getDateFormatParts,
  isSupportedDatePart
};
//# sourceMappingURL=date-format-parts.js.map
